import PreorderAPI from '@/api/preorder'

import SoundService from "@/services/sound";

import Vue from 'vue'

let isFirstRequest = true; 

const state = {
    preorders: [],
    error: null
};

const mutations = {
    setPreorders(state, payload) {
        state.preorders = payload;
    },
    setError(state, payload) {
        state.error = payload;

        // alert(`Сталася помилка при проведенні операції.`);
    },
    updatePreorder(state, payload) {
        state.preorders.forEach((preorder, index) => {
            if (preorder._id != payload._id) return;

            Vue.set(state.preorders, index, payload);
        });
    },
    removePreorder(state, payload) {
        const index = state.preorders.findIndex(it => it._id = payload._id);

        if (index === -1) return;

        state.preorders.splice(index, 1);
    }
};

const actions = {
    fetchPreorders(context) {
        return new Promise((resolve, reject) => {
            PreorderAPI.getPreorders().then(data => {
                // if (context.state.preorders.length == data.list.length) {
                //     resolve();
                //     return;
                // }

                if (!isFirstRequest && context.state.preorders.length < data.list.length) {
                    SoundService.playNewOrder();
                }
                
                context.commit('setPreorders', data.list);
                resolve();

                isFirstRequest = false;
            }).catch(error => {
                context.commit('setError', error);
                reject();
            });
        });
    },
    acceptPreorder(context, payload) {
        return new Promise((resolve, reject) => {
            PreorderAPI.acceptPreorder(payload.id, payload.waiting_time).then(data => {
                context.commit('updatePreorder', data.preorder);
                resolve();
            }).catch(error => {
                context.commit('setError', error);
                reject();
            });
        });
    },
    orderCar(context, payload) {
        return new Promise((resolve, reject) => {
            PreorderAPI.orderCar(payload.id, payload.time).then(data => {
                context.commit('updatePreorder', data.preorder);
                resolve();
            }).catch(error => {
                context.commit('setError', error);
                reject();
            });
        });
    },
    closePreorder(context, payload) {
        return new Promise((resolve, reject) => {
            PreorderAPI.closePreorder(payload).then(data => {
                context.commit('removePreorder', data.preorder);
                context.dispatch('fetchPreorders');
                resolve();
            }).catch(error => {
                context.commit('setError', error);
                reject();
            });
        });
    },
    sendPreorder(context, payload) {
        return new Promise((resolve, reject) => {
            PreorderAPI.sendPreorder(payload).then(data => {
                context.commit('updatePreorder', data.preorder);

                if (data.preorder.status == 'closed')
                    context.commit('removePreorder', data.preorder);  
                resolve();
            }).catch(error => {
                context.commit('setError', error);
                reject();
            });
        });
    },
    cancelPreorder(context, payload) {
        return new Promise((resolve, reject) => {
            PreorderAPI.cancelPreorder(payload.id, payload.reason).then(data => {
                context.commit('removePreorder', data.preorder);
                context.dispatch('fetchPreorders');
                resolve();
            }).catch(error => {
                context.commit('setError', error);
                reject();
            });
        });
    },
    convertToInside(context, payload) {
        return new Promise((resolve, reject) => {
            PreorderAPI.convertToInside(
                payload.preorder_id,
                payload.section,
                payload.table
            ).then(data => {
                context.dispatch('fetchPreorders');
                resolve();
            }).catch(error => {
                context.commit('setError', error);
                reject();
            })
        });
    }
};

const getters = {
    preordersOnly(state) {
        return state.preorders.filter(o => !o.is_delivery);
    },
    deliveriesOnly(state) {
        return state.preorders.filter(o => o.is_delivery);
    },
    findById(state) {
        return (id) => state.preorders.find(p => p._id == id);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}